import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { MainContentHeader } from '../components/MainContentHeader';
import { PaymentHistory } from './PaymentHistory';
import { trackPageView } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaymentHistoryPage = () => {
  useEffect(() => {
    trackPageView('payment-history-overview');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PAYMENT_HISTORY_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "700",
        children: [/*#__PURE__*/_jsx(MainContentHeader, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "paymentHistory.title"
          })
        }), /*#__PURE__*/_jsx(PaymentHistory, {})]
      })
    })
  });
};